export { default } from "./useTheme.js";
export * from "./useTheme.js";